import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Toast from './components/Toast';
import QRSuggester from './components/QRSuggester'; // ← ADD THIS
import Home from './pages/Home';
import './styles/global.css';

// Lazy load all pages except Home
const HowItWorks = lazy(() => import('./pages/HowItWorks'));
const Blog = lazy(() => import('./pages/Blog'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const NotFound = lazy(() => import('./pages/NotFound'));
const UPIGenerator = lazy(() => import('./pages/UPIGenerator'));
const WiFiGenerator = lazy(() => import('./pages/WiFiGenerator'));
const WhatsAppGenerator = lazy(() => import('./pages/WhatsAppGenerator'));
const QRScannerPage = lazy(() => import('./pages/QRScanner'));
const FreeQRGenerator = lazy(() => import('./pages/FreeQRGenerator'));
const PhoneQR = lazy(() => import('./pages/PhoneQR'));
const PaymentQR = lazy(() => import('./pages/PaymentQR'));
const ScanFromImage = lazy(() => import('./pages/ScanFromImage'));
const GooglePayQR = lazy(() => import('./pages/GooglePayQR'));
const NoSignupQR = lazy(() => import('./pages/NoSignupQR'));
const QRCardCreator = lazy(() => import('./pages/QRCardCreator'));
const StoryCreator = lazy(() => import('./pages/Storycreator'));
const BulkQRGenerator = lazy(() => import('./pages/BulkQRGenerator'));

// Loading spinner
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    fontSize: '1rem',
    opacity: 0.6
  }}>
    Loading...
  </div>
);

export default function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <Navbar />
          <main>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/upi-qr-code-generator" element={<UPIGenerator />} />
                <Route path="/wifi-qr-code-generator" element={<WiFiGenerator />} />
                <Route path="/whatsapp-qr-code-generator" element={<WhatsAppGenerator />} />
                <Route path="/qr-code-scanner-online" element={<QRScannerPage />} />
                <Route path="/free-qr-code-generator-india" element={<FreeQRGenerator />} />
                <Route path="/qr-code-for-phone-number" element={<PhoneQR />} />
                <Route path="/qr-code-for-payment" element={<PaymentQR />} />
                <Route path="/scan-qr-code-from-image" element={<ScanFromImage />} />
                <Route path="/google-pay-qr-code-generator" element={<GooglePayQR />} />
                <Route path="/qr-code-generator-no-signup" element={<NoSignupQR />} />
                <Route path="/qr-card-creator" element={<QRCardCreator />} />
                <Route path="/story-creator" element={<StoryCreator />} />
                <Route path="/bulk-qr-generator" element={<BulkQRGenerator />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <CookieBanner />
          <Toast />
          <QRSuggester /> {/* ← ADD THIS */}
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}